import Tray from './Tray'

export default Tray
